import React, { useCallback } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { CSSUnits } from "../../../../../builder/consts";

export const CSSUnitSelector = ({ value, setValue, disabled }) => {
  const handleClick = useCallback(
    (unit) => () => {
      if (disabled) {
        return;
      }
      setValue(unit);
    },
    [setValue, disabled]
  );

  return (
    <div className={classnames("dimension-input", { disabled })}>
      {CSSUnits.map((unit) => (
        <label
          key={unit}
          onClick={handleClick(unit)}
          className={classnames({ "active-label": value === unit })}
        >
          {unit.toUpperCase()}
        </label>
      ))}
    </div>
  );
};

CSSUnitSelector.propTypes = {
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

CSSUnitSelector.defaultProps = {
  disabled: false,
};
